import { Component, OnInit, inject } from '@angular/core';
import { RegistroService } from 'src/app/view/novo-cadastro/services/registro.service';
import { environment } from 'src/environments/environment';
import { Plano } from '../../model/dashboard';
import { DashboardCheckoutAssinaturaComponent } from '../dashboard-checkout-assinatura/dashboard-checkout-assinatura.component';
import { DashboardPlanoComponent } from '../dashboard-plano/dashboard-plano.component';

@Component({
  standalone: true,
    selector: 'app-dashboard-planos',
    imports: [
        DashboardPlanoComponent,
        DashboardCheckoutAssinaturaComponent,
    ],
    templateUrl: './dashboard-planos.component.html',
    styleUrl: './dashboard-planos.component.scss'
})
export class DashboardPlanosComponent implements OnInit {
  private service = inject(RegistroService);

  display = false;

  planos: Plano[] = [];
  planosSelecionados: Plano[] = [];
  idplan = -1;

  activeButtonYearPlan = false;
  activeButtonMotherPlan = true;
  activeButtonSemesterPlan = false;

  isProduction = environment.production;

  ngOnInit(): void {
    //  this.planos = planos;
    this.onSelectYearPlan();
    this.service.getPlans().subscribe({
      next: (response) => {
        this.planos = response;
        this.onSelectYearPlan();
      },
    });
  }

  onSelectYearPlan() {
    this.activeButtonYearPlan = true;
    this.activeButtonMotherPlan = false;
    this.activeButtonSemesterPlan = false;
    this.planosSelecionados = this.planos.filter((p) => p.tipo === 'A');
  }

  onSelectMotherPlan() {
    this.activeButtonYearPlan = false;
    this.activeButtonMotherPlan = true;
    this.activeButtonSemesterPlan = false;
    this.planosSelecionados = this.planos.filter((p) => p.tipo === 'M');
  }

  onSelectSemesterPlan() {
    this.activeButtonYearPlan = false;
    this.activeButtonMotherPlan = false;
    this.activeButtonSemesterPlan = true;
    this.planosSelecionados = this.planos.filter((p) => p.tipo === 'S');
  }

  onPurchasePlan(plan: Plano) {
    this.idplan = plan.id;
    this.display = true;
  }
}
